import st_login_h5 from './st_login.h5'

export default st_login_h5